import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Trash2, CheckCircle2, Circle, Euro } from "lucide-react";
import { sectionTag, sectionLabel } from "@/lib/sections";

function SignupRow({ camp, member, signup, onToggleSignup, onTogglePaid }) {
  return (
    <div className="flex items-center justify-between gap-3 py-1.5" data-testid={`signup-row-${member.id}`}>
      <div className="flex items-center gap-2 min-w-0">
        <button onClick={() => onToggleSignup(camp.id, member.id)} data-testid={`signup-toggle-${member.id}`}
          className="min-h-[44px] min-w-[44px] flex items-center justify-center">
          {signup ? <CheckCircle2 className="w-5 h-5 text-primary" /> : <Circle className="w-5 h-5 text-muted-foreground" />}
        </button>
        <div className="min-w-0">
          <div className={`text-sm font-medium truncate ${!signup && "text-muted-foreground"}`}>{member.full_name}</div>
          <span className={`scout-tag ${sectionTag(member.section)}`}>{sectionLabel(member.section)}</span>
        </div>
      </div>
      {signup && (
        <Button size="sm" variant={signup.paid ? "default" : "outline"} onClick={() => onTogglePaid(camp.id, member.id)}
          data-testid={`paid-toggle-${member.id}`}
          className={`min-h-[44px] ${signup.paid ? "bg-green-600 hover:bg-green-700 text-white" : ""}`}>
          <Euro className="w-3.5 h-3.5 mr-1" />{signup.paid ? "Paid" : "Mark paid"}
        </Button>
      )}
    </div>
  );
}

export default function CampCard({ camp: c, expanded, members, signups, onExpand, onDelete, onToggleSignup, onTogglePaid }) {
  const signedUp = (memberId) => signups.find((s) => s.member_id === memberId);
  return (
    <Card className="card-shadow-soft" data-testid={`camp-card-${c.id}`}>
      <CardContent className="p-5">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <button className="text-left flex-1" onClick={() => onExpand(c.id)} data-testid={`camp-expand-${c.id}`}>
            <div className="font-bold text-lg" style={{ fontFamily: "Outfit" }}>{c.title}</div>
            <div className="text-sm text-muted-foreground">
              {c.start_date}{c.end_date ? ` → ${c.end_date}` : ""}{c.location ? ` · ${c.location}` : ""}
            </div>
          </button>
          <div className="flex items-center gap-4">
            <div className="text-right">
              <div className="text-sm font-semibold" data-testid={`camp-stats-${c.id}`}>{c.signups_count} signed up · {c.paid_count} paid</div>
              <div className="text-xs text-muted-foreground">Fee: €{Number(c.fee).toFixed(2)}</div>
            </div>
            <Button size="icon" variant="ghost" onClick={() => onDelete(c.id)} data-testid={`camp-del-${c.id}`}>
              <Trash2 className="w-4 h-4 text-destructive" />
            </Button>
          </div>
        </div>
        {expanded && (
          <div className="mt-4 pt-4 border-t border-border space-y-2" data-testid={`camp-signups-${c.id}`}>
            {members.length === 0 && <div className="text-sm text-muted-foreground">No members to sign up.</div>}
            {members.map((m) => (
              <SignupRow key={m.id} camp={c} member={m} signup={signedUp(m.id)} onToggleSignup={onToggleSignup} onTogglePaid={onTogglePaid} />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
